import { FC } from "react";

import { User } from "../models/user-model";

import { UserView } from "./user-view";
import { UserViewEmpty } from "./user-view-empty";

interface UserViewOptionalProps {
  user?: User | null;
  logoOnly?: boolean;
  className?: string;
}

export const UserViewOptional: FC<UserViewOptionalProps> = ({ user, ...props }) => {
  if (!user) {
    return <UserViewEmpty {...props} />;
  }

  return <UserView user={user} {...props} />;
};
